module.exports = __webpack_public_path__ + "static/media/profile.d9252e67.png";